module.exports = __webpack_public_path__ + "5c114213/img/question-icon.06c20c5d.svg";